import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=18da0662&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=18da0662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da0662",
  null
  
)

export default component.exports